import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import User from "../user/User";
import Image from "../image/Image";
import JsonMappedModel from "../helpers/JsonMappedModel";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Video extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Video.id_attribute_name]: null,
      [Video.url_attribute_name]: null,
      [Video.user_attribute_name]: User,
      [Video.thumbnail_attribute_name]: Image
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getUrlAttributeName() {
    return Video.url_attribute_name;
  }
  static getThumbnailAttributeName() {
    return Video.thumbnail_attribute_name;
  }
  getAttributes() {
    return _classPrivateFieldGet(_attributes, this);
  }
  getId() {
    return this.getAttribute(Video.id_attribute_name);
  }
  getUrl() {
    return this.getAttribute(Video.url_attribute_name);
  }
  getVideoThumbnail() {
    return this.getAttribute(Video.thumbnail_attribute_name);
  }
  getPreviewImage() {
    let thumbnail = this.getVideoThumbnail();
    return thumbnail instanceof Image ? thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.getPreviewImage() : null;
  }
}
_defineProperty(Video, "id_attribute_name", 'video_id');
_defineProperty(Video, "url_attribute_name", 'video_url');
_defineProperty(Video, "user_attribute_name", 'user');
_defineProperty(Video, "thumbnail_attribute_name", 'thumbnail');